<h1 mat-dialog-title>
    <span translate>ndf.avancesImputables.title</span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view [liste]="listeAvancesImputables"></list-view>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="showCalculsFinaux()" [disabled]="isSaving || hasMontantInvalide">
        <span *ngIf="!isSaving">
            {{ (listeAvancesImputables.nbSelectedItems > 0 ? 'ndf.avancesImputables.boutonImputerAvances' : 'ndf.avancesImputables.boutonContinuer') | translate }}
        </span>
        <mat-spinner *ngIf="isSaving" class="m-5" diameter="28"></mat-spinner>
    </button>
</div>